import { render, staticRenderFns } from "./MultiSpecification.vue?vue&type=template&id=13adcd30&scoped=true"
import script from "./MultiSpecification.vue?vue&type=script&lang=js"
export * from "./MultiSpecification.vue?vue&type=script&lang=js"
import style0 from "./MultiSpecification.vue?vue&type=style&index=0&id=13adcd30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13adcd30",
  null
  
)

export default component.exports